exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2-italic-sm[data-v-78955c20] {\n    font-size: .50em !important;\n    font-style: italic !important; \n    font-weight: normal !important;\n}\n.indicator[data-v-78955c20] {\n    font-size: 1.25em;\n    font-weight: bold;\n    padding: 0;\n    line-height: 1.25rem;\n}    \n", ""]);

// exports
